var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),(_vm.authorized)?_c('Navbar'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath,class:{'main-info':_vm.authorized},attrs:{"idleTime":_vm.count},on:{"isIdle":_vm.checkIdle}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }